/**
 * Shared PrimeVue configuration.
 *
 * PrimeVue renders the "toggle all" control in a MultiSelect panel as a bare
 * checkbox with no visible text, so it reads as a blank first row that
 * mysteriously selects everything. PrimeVue exposes no slot at that position,
 * so the label is supplied two ways from the single constant below:
 *
 *  - visually, via a `data-select-all-label` attribute that
 *    `.p-multiselect-header::after` renders (see assets/main.css);
 *  - to assistive technology, via the checkbox's aria-label.
 */
export const SELECT_ALL_LABEL = 'Select All';

/**
 * PrimeVue picks the toggle-all aria-label from `locale.aria`, switching on
 * whether everything is currently selected. Both states use the same action
 * label so it matches the visible text; the checkbox's own checked state
 * already conveys whether the options are selected.
 */
export const primeVueLocale = {
  aria: {
    selectAll: SELECT_ALL_LABEL,
    unselectAll: SELECT_ALL_LABEL,
  },
};

export const primeVuePassThrough = {
  multiselect: {
    // PrimeVue also renders this header row when only the filter input is
    // present, so the label is emitted only when the toggle-all checkbox is
    // actually there to be labeled.
    header: ({ props }) => ({
      'data-select-all-label':
        props.showToggleAll && props.selectionLimit == null ? SELECT_ALL_LABEL : undefined,
    }),
  },
};
